"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodManager = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
const Instance_1 = require("../../model/Instance");
const MethodServerResponse_1 = require("../../model/MethodServerResponse");
const synerisMethods_1 = require("../Menu/synerisMethods");
const synerisMethods_customer_1 = require("../Menu/synerisMethods_customer");
let $ = require("jquery");
class MethodManager {
    static doMethodChecksBeforeExcecution(menuEntry, context, fullSelectionContext) {
        if (menuEntry.style & synerisMethods_1.methodStyles.UseSelectedObjectAsContextInTree && fullSelectionContext.parentControl) {
            context.parentId = fullSelectionContext.parentControlParentContext.parentId;
            context.relid = fullSelectionContext.parentControlParentContext.parentRelId;
        }
    }
    static doMethodChecksAfterExcecution(menuEntry, context, commandTriggerTarget, serverResponse) {
        commandTriggerTarget.trigger("forceRefresh", serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.modifications);
    }
    static executeMethodWithoutMenu(method, selectionContext, commandTriggerTarget) {
        let context = {
            ids: selectionContext.selectedIds,
            parentId: selectionContext.normalParentContext.parentId,
            relid: selectionContext.normalParentContext.parentRelId
        };
        MethodManager.doMethodChecksBeforeExcecution(method, context, selectionContext);
        MethodManager.executeMethod(method, context.ids, context.parentId, context.relid, function (serverExecuted, serverResponse) {
            commandTriggerTarget.trigger("afterExecuteMethod", method.method);
            if (serverExecuted) {
                MethodManager.doMethodChecksAfterExcecution(method, context, commandTriggerTarget, serverResponse);
                Utilities_1.synUtil.Notifications.menuSuccess(method.method);
            }
        });
    }
    static executeMethodForMenu(menuEntry, commandLayouts, menu, commandTriggerTarget) {
        let selectionContext = commandLayouts.SelectionContext.FullSelectionContext;
        if (selectionContext === null || selectionContext === void 0 ? void 0 : selectionContext.normalParentContext) {
            let continueObject = {
                continueExec: true,
                context: {
                    ids: selectionContext.selectedIds,
                    parentId: selectionContext.normalParentContext.parentId,
                    relid: selectionContext.normalParentContext.parentRelId,
                    version: selectionContext.version,
                    doexecute: true
                },
                additionalData: {},
                dataItem: menuEntry,
                continueCallback() {
                    if (this.continueExec) {
                        if (!menuEntry.items || !menuEntry.items.length) {
                            let that = this;
                            MethodManager.doMethodChecksBeforeExcecution(menuEntry, that.context, commandLayouts.SelectionContext.FullSelectionContext);
                            if (!that.context.doexecute)
                                return;
                            // HACK
                            if (menuEntry.method === "menurefreshinclshorcut")
                                commandTriggerTarget.trigger("forceRefresh", undefined);
                            else {
                                if (menuEntry.fulllicense)
                                    menu.trigger("menuLogFullLicense");
                                let addlData = $.extend({ version: selectionContext.version }, that.additionalData);
                                MethodManager.executeMethod(menuEntry, that.context.ids, that.context.parentId, parseInt(that.context.relid, 10), function (serverExecuted, serverResponse) {
                                    commandTriggerTarget.trigger("afterExecuteMethod", menuEntry.method);
                                    if (serverExecuted) {
                                        MethodManager.doMethodChecksAfterExcecution(menuEntry, that.context, commandTriggerTarget, serverResponse);
                                        Utilities_1.synUtil.Notifications.menuSuccess(menuEntry.method);
                                    }
                                }, addlData);
                            }
                        }
                    }
                }
            };
            if ((!menuEntry.items || !menuEntry.items.length) && commandLayouts.RaiseBeforeExecuteMethod && !menuEntry.ignoreChanges)
                commandTriggerTarget.trigger("beforeExecuteMethod", [continueObject]);
            else
                continueObject.continueCallback();
        }
    }
    /**
    * Execute a method/menuentry
    *
    * @param method May be string or method object (dataItem)
    * @param instance May be string[] (ids) or instance object
    * @param options is used to handle special client behavior (i.e. newWindow > new window for cefunc.2 when called from methodButton)
    */
    static executeMethod(method, instance, parentId, relId, completedHandler, options) {
        let ids = [];
        if (instance instanceof Instance_1.Instance) {
            if (!instance)
                ids = [];
            else
                ids = [instance.id.valueAsString];
        }
        else {
            if (instance)
                ids = instance;
            else
                ids = [];
        }
        if (!completedHandler)
            completedHandler = (s, r) => { };
        if (typeof method === "object") {
            // Methode hat eine eigene Implementierung bzw. überschreibt die Standardimplementierung
            if (method.impl)
                method.impl(ids, parentId, relId, completedHandler, options);
            else if (method.method)
                MethodManager.executeMethodStringCore(method.method, instance, parentId, relId, completedHandler, options);
            else
                Utilities_1.synUtil.Notifications.error(kendo.format(Utilities_1.synUtil.Strings.getValue("menunomethodassigned"), Utilities_1.synUtil.Strings.getValue(method.text)));
        }
        else
            MethodManager.executeMethodStringCore(method, instance, parentId, relId, completedHandler, options);
    }
    static executeMethodStringCore(methodId, instance, parentId, relId, completedHandler, options) {
        // Methods sind als JS-Objekte/Unterobjekte angelegt, 2 Ebenen werden berücksichtigt
        let methodArr = methodId.split('.');
        let synMethod;
        let waitingNotificaton;
        switch (methodArr.length) {
            case 1:
                synMethod = synerisMethods_customer_1.synerisMethodsCustomer[methodArr[0]];
                if (!synMethod)
                    synMethod = synerisMethods_1.synerisMethods[methodArr[0]];
                break;
            case 2:
                if (typeof synerisMethods_customer_1.synerisMethodsCustomer[methodArr[0]] != "undefined")
                    synMethod = synerisMethods_customer_1.synerisMethodsCustomer[methodArr[0]][methodArr[1]];
                if (typeof synMethod === "undefined" && typeof synerisMethods_1.synerisMethods[methodArr[0]] != "undefined")
                    synMethod = synerisMethods_1.synerisMethods[methodArr[0]][methodArr[1]];
                break;
            default:
                synMethod = undefined;
                break;
        }
        // Methode wird ausschließlich serverseitig abgehandelt (Kernelmethoden ohne Oberfläche)
        if (!synMethod) {
            let params = {
                method: methodId,
                parentId,
                relId,
                done(dataJSON) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let data = yield MethodServerResponse_1.MethodServerResponse.fromJSON(dataJSON);
                        if (completedHandler)
                            completedHandler(true, data);
                    });
                },
                cleanUp() {
                    Utilities_1.synUtil.Notifications.remove(waitingNotificaton);
                },
                additionalData: undefined,
                ids: undefined,
                instanceData: undefined
            };
            params.additionalData = options;
            if (instance) {
                if (instance instanceof Instance_1.Instance) {
                    params.instanceData = JSON.stringify([instance.toJSON()]);
                }
                else {
                    params.ids = instance;
                }
            }
            let waitMsg = kendo.format(Utilities_1.synUtil.Strings.getValue("menuexecute"), Utilities_1.synUtil.Strings.getValue(methodId));
            waitingNotificaton = Utilities_1.synUtil.Notifications.waiting(waitMsg, { showAfter: 2000 });
            Utilities_1.synUtil.executeMethod(params);
        }
        else {
            let ids = [];
            if (instance instanceof Instance_1.Instance) {
                if (!instance)
                    ids = [];
                else
                    ids = [instance.id.valueAsString];
            }
            else {
                if (instance)
                    ids = instance;
                else
                    ids = [];
            }
            synMethod.impl(ids, parentId, relId, completedHandler, options);
        }
    }
}
exports.MethodManager = MethodManager;
